import Service from './Service'
import { ACCESS, PROMOTEUR_ACCESSES, ALLOTMENTS } from './apiUrls'

export default class AccessService extends Service {
  // To create program access with allotment, pass {allotments: [<lotPk>, <lotPk>, ...]}
  deleteMany (query) {
    return this.axios.delete(`${ACCESS}`, {params: query})
  }
  getOnePromoteurAccess (id) {
    return this.axios.get(`${PROMOTEUR_ACCESSES}/${id}`)
  }
  getPromoteurAccess (query) {
    return this.axios.get(PROMOTEUR_ACCESSES, {params: query})
  }
  patchPromoteurAccess (id, data) {
    return this.axios.patch(`${PROMOTEUR_ACCESSES}/${id}`, data)
  }
  postPromoteurAccess (data) {
    return this.axios.post(`${PROMOTEUR_ACCESSES}`, data)
  }
  deletePromoteurAccess (id) {
    return this.axios.delete(`${PROMOTEUR_ACCESSES}/${id}`)
  }
  getAllotments (query) { // pass params {lot: <lot_pk>, program: <program_pk>, company: <company_pk>, access: <access_pk>}
    return this.axios.get(`${ALLOTMENTS}`, {params: query})
  }
  postAllotments (data) { // send {access_pk: <access_pk>, lots : [<lot_pk>, <lot_pk>, <lot_pk>]}
    return this.axios.post(`${ALLOTMENTS}`, data)
  }
  deleteAllotments (data) { // send [<allotment_pk>, <allotment_pk>, <allotment_pk>]
    return this.axios.delete(`${ALLOTMENTS}`, {data})
  }
  getLotFromAccesses (id, query) {
    return this.axios.get(`${ACCESS}/${id}/${ALLOTMENTS}`, {params: query})
  }
  postLotAccess (id, data) { // send {lot: <lot_pk>}
    return this.axios.post(`${ACCESS}/${id}/${ALLOTMENTS}`, data)
  }
  deleteLotAccess (id) {
    return this.axios.delete(`${ALLOTMENTS}/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/AccessService.js